module.exports = "mat-icon.detail {\n  cursor: pointer; }\n\nmat-chip {\n  background-color: #dcdcdc !important; }\n\nmat-chip.green {\n    background-color: #00c853 !important; }\n\nmat-chip.red {\n    background-color: #ff736d !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/orders/orders.component.scss
// module id = ./src/app/pages/orders/orders.component.scss
// module chunks = main